// extracted by mini-css-extract-plugin
module.exports = {"price-discount":"_33974c2b58--price-discount--MVnxK","old-price":"_33974c2b58--old-price--X2tCp"};